import { Link } from "gatsby";
import preptemberslides from "../../../../src/collections/events/2024/hacktoberfest-2024/hacktoberfest-prep-2024-extending-meshery-models.pdf";
import hacktoberfestBadge from "../../../../src/collections/events/2024/hacktoberfest-2024/layer5-hacktoberfest11-badge-large.png";
import * as React from 'react';
export default {
  Link,
  preptemberslides,
  hacktoberfestBadge,
  React
};